import React, {useState, useEffect} from 'react';
import {useParams} from "react-router-dom";
import {withTranslation} from 'react-i18next';
import {ProgressBar} from 'primereact/progressbar';
import axios from "axios";

const ContactpartnerShowComponent = (props) => {

  const {t} = props;
  const {id} = useParams();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({});

  const apiCall = (method, url, data) => {
    return axios({
      method: method,
      url: process.env.REACT_APP_API_HOST + url,
      data,
      params: {},
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
        'App-Network': localStorage.getItem("networkId")
      }
    })
  }

  useEffect(() => {
    if (id) {
      setLoading(true);
      apiCall('get', '/api/v2/contact-partner?search[partner][operator]==&search[partner][value]=' + id)
        .then(response => {
          setFormData(response.data.data.items[0])
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        })
    }
  }, [window.App.state.rerenderContactpartnerList])

  return (
    <div className={"costitem-form widget"}>
      {loading &&
        <ProgressBar mode="indeterminate"
                     style={{height: '5px', position: "absolute", top: 0, left: 0, borderRadius: 0,}}></ProgressBar>
      }
      <div className={"p-grid"}>
        <div className={"p-col-12 p-lg-6"}>
          <div className="p-field p-fluid">
            <label htmlFor="name">{t('columnName2')}</label>
            <span className="p-d-block fake-input">
              {formData?.contact?.name ?? ''}
            </span>
          </div>
        </div>
        <div className={"p-col-12 p-lg-6"}>
          <div className="p-field p-fluid">
            <label htmlFor="code">{t('columnAbbreviation')}</label>
            <span className="p-d-block fake-input">
              {formData?.position  ?? ''}
            </span>
          </div>
        </div>
        <div className={"p-col-12 p-lg-6"}>
          <div className="p-field p-fluid">
            <label htmlFor="code">{t('columnPhoneNumber')}</label>
            <span className="p-d-block fake-input">
              {formData?.contact?.phone  ?? ''}
            </span>
          </div>
        </div>
        <div className={"p-col-12 p-lg-6"}>
          <div className="p-field p-fluid">
            <label htmlFor="code">{t('columnEmail')}</label>
            <span className="p-d-block fake-input">
              {formData?.contact?.email  ?? ''}
            </span>
          </div>
        </div>
        <div className={"p-col-12 p-lg-6"}>
          <div className="p-field p-fluid">
            <label htmlFor="code">{t('columnComment')}</label>
            <span className="p-d-block fake-input">
              {formData?.contact?.note  ?? ''}
            </span>
          </div>
        </div>
      </div>
    </div>
  )
}
export default withTranslation('common')(ContactpartnerShowComponent);
